import React from 'react';
import styled from 'styled-components';

import { Row } from '@prisjakt/ui/list/variants';
import { BodyMediumText, H4Text, FontColor } from '@prisjakt/ui/text/variants';
import Clickable from '@prisjakt/ui-clickable';

import { useAppContext } from '@prisjakt/ui-app-context';
import { trackSearchDidYouMeanClicked } from '../../tracking';

type Props = {
  queries: string[];
  searchQuery: string;
};

export const DidYouMean = (props: Props) => {
  const { queries, searchQuery } = props;
  const { t, linkTo } = useAppContext();

  const handleClick = (query: string) => {
    trackSearchDidYouMeanClicked(query, searchQuery);
  };

  return (
    <DidYouMeanWrapper gap={1}>
      <BodyMediumText>{t('search', 'search.did-you-mean')}</BodyMediumText>

      <>
        {queries.map(query => (
          <Clickable
            key={query}
            onClick={() => handleClick(query)}
            to={linkTo('search', { query })}
          >
            <H4Text color={FontColor.PRIMARY}>{query}</H4Text>
          </Clickable>
        ))}
      </>
    </DidYouMeanWrapper>
  );
};

const DidYouMeanWrapper = styled(Row)`
  > * {
    flex: 0 1 auto;
  }
`;
